<template>
  <el-form-item 
    :label="name || 'No label'"
    :class="{ hidden: hidden }"
  >
    <el-popover
      v-model="popover"
      placement="top"
      title="Edit field"
      width="350"
      trigger="manual"
    >
      <div>
        <el-form size="small">
          <el-col :span="12">
            <el-form-item label="Label">
              <el-input v-model.trim="name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Type">
              <el-select
                v-model="type"
                style="width:100%;"
              >
                <el-option
                  v-for="item in attributes.types"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item style="text-align: right;">
              <el-button
                type="danger"
                @click="onRemoveFiled"
              >Remove</el-button>
              <el-button @click="popover = false">Close</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div
        slot="reference"
        class="popover-pos"
      />
    </el-popover>
    <i
      v-if="isAddonField"
      class="field-settings el-icon-setting"
      @click="onEdit"
    />
    <el-input
      v-if="type==='checkbox'"
      v-model.trim="value"
      :checked="visible"
      :class="{ toggle: isToggle}"
      :type="type"
      :id="`index`+index"
      @click.native="toggle"
    />
     <el-input
      v-else
      v-model.trim="value"
      :checked="value"
      :type="type"
      :id="`index`+index"
      @click.native="toggle"
    />
    <!-- addresses -->
    <el-select
      v-if="type==='checkbox'"
      v-model="addressChosen"
      @change="changeAddress"
      style="width:100%;"
      :class="{ visible: isVisible }"
      label="Address"
      v-show="visible"
    >
      <el-option
        v-for="item in this.$store.getters.getMarketplaces"
        :key="item.lang"
        :value="item.address"
        :label="item.lang"
      />
    </el-select>
  </el-form-item>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: '',

  props: {
    isAddonField: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
  },

  data () {
    return {
      popover: false,
      visible: false,
      isToggle: true,
      isVisible: false,
      addressChosen: null
    }
  },

  computed: {
    ...mapState(['basic', 'attributes', 'marketplaces']),
    value: {
      get () {
        return this.basic.fields[this.index].value
      },
      set (v) {
        if(this.basic.fields[this.index].type === "checkbox") {
          if(v==0 || v=='0') {
            this.basic.fields[6].value = '';
          }
          this.visible = this.visible ? false : true;

        }
        this.$store.dispatch('updateField', { index: this.index, data: { value: v } })
      }
    },
    name: {
      get () {
        return this.basic.fields[this.index].name
      },
      set (v) {
        this.$store.dispatch('updateField', { index: this.index, data: { name: v } })
      }
    },
    type: {
      get () {
        return this.basic.fields[this.index].type
      },
      set (v) {
         if(this.basic.fields[this.index].type === "checkbox") {
          if(v==0 || v=='0') {
            this.basic.fields[6].value = '';
          }
          this.visible = this.visible ? false : true;
        }
        this.$store.dispatch('updateField', { index: this.index, data: { type: v } })
      }
    },
    hidden: {
      get () {
        return this.basic.fields[this.index].hidden
      },
      set (v) {
        this.$store.dispatch('updateField', { index: this.index, data: { hidden: v } })
      }
    }
  },
  methods: {
    onEdit () {
      this.popover = !this.popover
    },
    onRemoveFiled () {
      this.$store.dispatch('removeField', this.index)
    },
    toggle () {
      this.isVisible = !this.isVisible;
    },
    changeAddress () {
      this.basic.fields[6].value = this.addressChosen;
    }
  },
}
</script>

<style lang="scss">
@import '../assets/scss/variables';

$base: #3D83DF;
$whiteLight: #fafafa;

.field-settings {
  position: absolute;
  right: -10px;
  top: 4px;
  color: $color-info;
  cursor: pointer;
  padding: 10px;
  &:hover {
    color: $color-primary;
  }
}
.popover-pos {
  position: relative;
  top: 20px;
}
input[type='checkbox']{
  display:none; //hide by default
  cursor:pointer; //make the cursor a pointer when over the items
  &:focus,
  &:active{
    outline:none;  //remove the annoying outline
  }
 & + label{
   cursor:pointer; 
   display:inline-block;
   position: relative;
   padding-left:25px;
   margin-right:10px;
   color: darken($base, 20%);
   &:before,
   &:after{
    content:'';
    font-family: helvetica;
    display:inline-block;
    width:18px;
    height:18px;      
    left:0;
    bottom:0;
    text-align:center;
    position: absolute;
    }
   &:before{
    background-color:$whiteLight;
    transition: all .3s ease-in-out;
   }
   &:after{
    color:#fff;
    }
  }
  &:checked + label:before{
    box-shadow: inset 0 0 0 10px $base;
  }
}
/*Toggle Specific styles*/
.hidden{
  display:none;
}
.visible{
  display:block!important;
}
.toggle{
  input[type='checkbox']{
    display:none;
    display:inline-block;
    -webkit-appearance:none;
    -moz-appearance:none;
    appearance:none;
    width:55px;
    height:28px;
    background-color:$whiteLight;
    position: relative;
    border-radius: 30px;
    box-shadow: none;
    transition: all .2s ease-in-out;
    &:hover:after{
    background-color: darken($whiteLight, 20%);
    }
    &:after{      
      content:'';
      display:inline-block;
      position:absolute;
      width:24px;
      height:24px;
      background-color:darken($whiteLight, 30%);
      top:1px;
      left:2px;
      border-radius: 50%;
      transition: all .2s ease-in-out;
    }
    &:checked{
      box-shadow: inset 0 0 0 15px $base;
      &:after{
        left:29px;
        background-color:#fff;
      }
    }
  }
}
</style>
